/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Tabs_ActivityInputs */

const id_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitas`)
};

const ms_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviti`)
};

const da_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

const de_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivität`)
};

const en_us2_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

const es_es2_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad`)
};

const es_mx2_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad`)
};

const fil_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktibidad`)
};

const fr_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité`)
};

const it_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività`)
};

const hu_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tevékenység`)
};

const nl_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activiteit`)
};

const no_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

const pl_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywność`)
};

const pt_br2_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

const pt_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

const ro_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activitate`)
};

const fi_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toiminta`)
};

const sv_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

const vi_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động`)
};

const tr_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivite`)
};

const cs_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivita`)
};

const bg_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активност`)
};

const ru_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активность`)
};

const uk_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активність`)
};

const ar_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشاط`)
};

const hi_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गतिविधि`)
};

const th_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรม`)
};

const ja_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティビティ`)
};

const zh_cn2_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动态`)
};

const zh_hant1_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動態`)
};

const ko_profile_tabs_activity = /** @type {(inputs: Profile_Tabs_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활동`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Profile_Tabs_ActivityInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_tabs_activity = /** @type {((inputs?: Profile_Tabs_ActivityInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Tabs_ActivityInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_tabs_activity(inputs)
	if (locale === "ms") return ms_profile_tabs_activity(inputs)
	if (locale === "da") return da_profile_tabs_activity(inputs)
	if (locale === "de") return de_profile_tabs_activity(inputs)
	if (locale === "en-US") return en_us2_profile_tabs_activity(inputs)
	if (locale === "es-ES") return es_es2_profile_tabs_activity(inputs)
	if (locale === "es-MX") return es_mx2_profile_tabs_activity(inputs)
	if (locale === "fil") return fil_profile_tabs_activity(inputs)
	if (locale === "fr") return fr_profile_tabs_activity(inputs)
	if (locale === "it") return it_profile_tabs_activity(inputs)
	if (locale === "hu") return hu_profile_tabs_activity(inputs)
	if (locale === "nl") return nl_profile_tabs_activity(inputs)
	if (locale === "no") return no_profile_tabs_activity(inputs)
	if (locale === "pl") return pl_profile_tabs_activity(inputs)
	if (locale === "pt-BR") return pt_br2_profile_tabs_activity(inputs)
	if (locale === "pt") return pt_profile_tabs_activity(inputs)
	if (locale === "ro") return ro_profile_tabs_activity(inputs)
	if (locale === "fi") return fi_profile_tabs_activity(inputs)
	if (locale === "sv") return sv_profile_tabs_activity(inputs)
	if (locale === "vi") return vi_profile_tabs_activity(inputs)
	if (locale === "tr") return tr_profile_tabs_activity(inputs)
	if (locale === "cs") return cs_profile_tabs_activity(inputs)
	if (locale === "bg") return bg_profile_tabs_activity(inputs)
	if (locale === "ru") return ru_profile_tabs_activity(inputs)
	if (locale === "uk") return uk_profile_tabs_activity(inputs)
	if (locale === "ar") return ar_profile_tabs_activity(inputs)
	if (locale === "hi") return hi_profile_tabs_activity(inputs)
	if (locale === "th") return th_profile_tabs_activity(inputs)
	if (locale === "ja") return ja_profile_tabs_activity(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_tabs_activity(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_tabs_activity(inputs)
	return ko_profile_tabs_activity(inputs)
});
export { profile_tabs_activity as "profile.tabs.activity" }